import React from 'react';
import classnames from 'classnames';

import { List } from '../client-common';
import clientStyle from '../index.less';

import { CardFieldProps } from '../typings';

type ConvLiteInfoProps = {
  attrs?: Array<CardFieldProps>;
  convLiteInfo?: Record<string, string>;
};

const ConvLiteInfo = ({ attrs, convLiteInfo }: ConvLiteInfoProps): JSX.Element => {
  if (!convLiteInfo || !Object.entries(convLiteInfo).length) {
    return <div id="conv" className={classnames(clientStyle.tabpane)}></div>;
  }
  const data = Object.entries(convLiteInfo).map(info => {
    const key = info[0];
    const value = info[1];
    const attr = attrs?.find(a => a.name === key);
    return {
      label: attr?.display_name || attr?.name || '',
      children: value
    };
  });

  return (
    <div id="conv" className={classnames(clientStyle.tabpane)}>
      <List data={data} />
      <p className={clientStyle.tips}>*以上数据均为本次对话参数</p>
    </div>
  );
};

export default ConvLiteInfo;
